import { TFunction } from 'i18next';
import { ROUTES } from '@/constants/routes';
import { getUrlBasedOnAuth, getNewAdPageHref } from '@/utils/helpers';

export const tabBarLinks = (
  t: TFunction,
  isAuthLoaded: boolean,
  isAuthenticated: boolean,
  currentUrl: string
) => {
  return [
    {
      href: ROUTES.home,
      iconName: 'home',
      isBig: false,
      text: t('common.main'),
    },
    {
      href: ROUTES.bookmarks,
      iconName: 'favorites',
      isBig: false,
      text: t('common.favorites'),
      isDisabled: currentUrl === ROUTES.bookmarks,
    },
    {
      href: getNewAdPageHref(currentUrl),
      iconName: 'add',
      isBig: true,
      text: t('common.add'),
    },
    {
      href: isAuthLoaded
        ? getUrlBasedOnAuth(isAuthenticated, ROUTES.messages, currentUrl)
        : ROUTES.messages,
      iconName: 'messages',
      isBig: false,
      text: t('common.messages'),
    },
    {
      href: isAuthLoaded
        ? getUrlBasedOnAuth(isAuthenticated, ROUTES.profile, currentUrl)
        : ROUTES.profile,
      iconName: 'cabinet',
      isBig: false,
      text: t('common.cabinet'),
    },
  ];
};
